/* istanbul ignore file */
import { getReport } from "./getReport";

/**
 * Async function to get all visuals from current report
 * @returns VisualDescriptor[]
 */
export const getVisuals = async () => {
  const report = getReport();
  if (!report) {
    return null;
  }
  const page = await report.getActivePage();
  return await page.getVisuals();
};
